import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=06b542ef&"
import script from "./ChatContact.vue?vue&type=script&lang=ts&"
export * from "./ChatContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports